import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sidebar as FlowbiteSidebar, Badge } from 'flowbite-react';
import { 
  HiChartPie, 
  HiViewGrid, 
  HiUsers, 
  HiHome, 
  HiMail,
  HiArrowLeft,
  HiCog,
  HiCollection
} from 'react-icons/hi';

export default function Sidebar({ currentApp }) {
  const location = useLocation();
  const appId = currentApp?.id;
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <FlowbiteSidebar aria-label="Dashboard sidebar">
      <FlowbiteSidebar.Items>
        <FlowbiteSidebar.ItemGroup>
          {appId && (
            <FlowbiteSidebar.Item
              as={Link}
              to="/apps"
              icon={HiArrowLeft}
              className={isActive('/apps') ? 'bg-gray-100 dark:bg-gray-700' : ''}
            >
              Все приложения
            </FlowbiteSidebar.Item>
          )}
        </FlowbiteSidebar.ItemGroup>

        {appId && (
          <>
            <FlowbiteSidebar.ItemGroup>
              <div className="px-3 py-2 border-b border-gray-200 mb-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                  Приложение
                </p>
                                 <p className="text-sm font-medium text-gray-900 mt-1">
                  <Link to={`/${appId}/dashboard`} className="underline underline-offset-2 decoration-blue-500 hover:text-blue-700">{currentApp.name}</Link>
                 </p>
              </div>
              
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/dashboard`}
                icon={HiChartPie}
                className={isActive(`/${appId}/dashboard`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Обзор
              </FlowbiteSidebar.Item>
              
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/properties`}
                icon={HiHome}
                className={isActive(`/${appId}/properties`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Объекты
                {currentApp.properties > 0 && (
                  <Badge color="info" className="ml-auto" size="xs">{currentApp.properties}</Badge>
                )}
              </FlowbiteSidebar.Item>
              
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/users`}
                icon={HiUsers}
                className={isActive(`/${appId}/users`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Пользователи
                {currentApp.users > 0 && (
                  <Badge color="success" className="ml-auto" size="xs">{currentApp.users}</Badge>
                )}
              </FlowbiteSidebar.Item>
              
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/broadcasts`}
                icon={HiMail}
                className={isActive(`/${appId}/broadcasts`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Рассылки
              </FlowbiteSidebar.Item>
            </FlowbiteSidebar.ItemGroup>

            <FlowbiteSidebar.ItemGroup>
              <div className="px-3 py-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                  Настройки
                </p>
              </div>
              
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/settings`}
                icon={HiCog}
                className={isActive(`/${appId}/settings`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Настройки приложения
              </FlowbiteSidebar.Item>
              <FlowbiteSidebar.Item
                as={Link}
                to={`/${appId}/bot`}
                icon={HiMail}
                className={isActive(`/${appId}/bot`) ? 'bg-gray-100 dark:bg-gray-700' : ''}
              >
                Чат-бот
              </FlowbiteSidebar.Item>
            </FlowbiteSidebar.ItemGroup>
          </>
        )}

        {!appId && (
          <FlowbiteSidebar.ItemGroup>
            <FlowbiteSidebar.Item
              as={Link}
              to="/apps"
              icon={HiViewGrid}
              className={isActive('/apps') ? 'bg-gray-100 dark:bg-gray-700' : ''}
            >
              Мои приложения
            </FlowbiteSidebar.Item>
            
            <FlowbiteSidebar.Item
              as={Link}
              to="/apps/new"
              icon={HiCollection}
              className={isActive('/apps/new') ? 'bg-gray-100 dark:bg-gray-700' : ''}
            >
              Создать приложение
            </FlowbiteSidebar.Item>
          </FlowbiteSidebar.ItemGroup>
        )}
      </FlowbiteSidebar.Items>
    </FlowbiteSidebar>
  );
}